import MailIcon from '@/assets/icons/mail.svg?react';
import { Button } from '@/lib';
import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { ResetPasswordHeader } from '../components';

export const ResetPasswordCompleteContent: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <ResetPasswordHeader
        icon={<MailIcon />}
        title='ALL:checkYourEmail'
        subtitle={
          <Trans
            i18nKey='ALL:weSentNewPasswordTo'
            components={{
              bold: <b className='font-medium' />,
            }}
          />
        }
      />
      <Button text={t('ALL:iUnderstand')} className='w-full' />
    </>
  );
};
